module.exports = __webpack_public_path__ + "static/img/SAM-SWADLING.3c2092e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SAM-SWADLING.jpg
// module id = EjGH
// module chunks = 0